import React from 'react'
import Navbaar from '../Navbaar/Navbaar'
import Hero from '../Hero/Hero'
import Footer from '../Footer/Footer'
function Home() {
  return (
    <div>
      <Navbaar/>
      <Hero/>
      <Footer/>
    </div>
  )
}

export default Home
